/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {},
  HEADER: {
    CHALLENGE_DESCRIPTION: 'Περιγραφή',
    END_DATE: 'Μέχρι το',
    ID: 'Id',
    OBJECTIVE: 'Στόχος',
    REWARD: 'Βραβείο',
    START_DATE: 'Από το'
  },
  LABEL: {
    ACCUMULATED_VALUE: 'Συσσωρευμένη αξία',
    ACTIVES: 'Περιουσιακά στοιχεία',
    AT: 'Στο',
    COUPON: 'Κουπόνι',
    CREATED: 'Δημιουργήθηκε',
    DAY_VALUE: 'Ημέρα αξίας',
    FAIL: 'Αποτυχία',
    FINISHED: 'Τελειωμένο',
    HISTORY: 'Ιστορία',
    IN_PROGRESS: 'Σε εξέλιξη',
    MONETARY_REWARD: 'Αξία πριμοδότησης',
    NR_ACCESSES: 'Αριθμός προσβάσεων',
    NR_NEW_CLIENTS: 'Νέοι πελάτες',
    NR_ORDERS: 'Αριθμός παραγγελιών',
    OBJECTIVE: 'Στόχος',
    OBJECTIVE_VALUE: 'Τιμή-στόχος',
    OFFER: 'Προσφορά',
    OPEN: 'Ανοίξτε το',
    REMUNERATION: 'Αποδοχές',
    REWARD_TYPE: 'Τύπος ανταμοιβής',
    REWARD_TYPES: 'Τύποι βραβείων',
    SALES: 'Πωλήσεις',
    SALES_BRANDS: 'Πωλήσεις των επώνυμων σειρών (€)',
    SALES_BRANDS_QTY: 'Πωλήσεις επώνυμων σειρών (Ποσότητα)',
    SALES_CATEGORY: 'Κατηγορία πωλήσεων (€)',
    SALES_CATEGORY_QTY: 'Πωλήσεις κατηγορίας (Ποσότητα)',
    SALES_COMMISSIONS: 'Προμήθειες επί των πωλήσεων',
    SALES_PRODUCTS: 'Πωλήσεις προϊόντων (€)',
    SALES_PRODUCTS_QTY: 'Πωλήσεις προϊόντων (Ποσότητα)',
    SUCCESS: 'Επιτυχία',
    TO: '{0} μέχρι το {1}',
    TODAY: 'Σήμερα'
  },
  SENTENCE: {
    CHALLANGES_DESCRIPTION: 'Δεν υπάρχουν ενεργές προκλήσεις (ακόμα)',
    CHALLANGES_TITLE: 'Δεν υπάρχουν προκλήσεις.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
